import React, {Component} from "react";
import ReactDOM from "react-dom";
import Closeable from "./Closeable";

interface ShowHideMenuState {
  visible: boolean;
}

export interface ShowHideMenuProps {
  menu: React.ReactNode;
  onVisibleChange: (visible: boolean) => void;
}

export default class ShowHideMenu extends Component<ShowHideMenuProps, ShowHideMenuState> {
  constructor(props: ShowHideMenuProps) {
    super(props);

    this.state = {
      visible: false
    }

    this.onMenuItemClick = this.onMenuItemClick.bind(this);
    this.handleEscape = this.handleEscape.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  handleClickOutside(event: MouseEvent) {
    const domNode = ReactDOM.findDOMNode(this);

    if (!domNode || !domNode.contains(event.target as any)) {
      this.setState({
        visible : false
      });
      this.props.onVisibleChange(false);
    }
  }

  handleEscape() {
    this.setState({
      visible : false
    });
    this.props.onVisibleChange(false);
  }

  onMenuItemClick() {
    const isVisible = !this.state.visible;
    this.setState({
      visible: isVisible
    });

    this.props.onVisibleChange(isVisible);
  }

  render() {
    return (
      <Closeable onClickOutside={this.handleEscape} onEscape={this.handleEscape}>
        <div onClick={this.onMenuItemClick}>
          {this.props.children}
        </div>
        {this.state.visible ? this.props.menu : ""}
      </Closeable>
    )
  }
}
